import { push } from '@lagunovsky/redux-react-router'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { H_CAMPAIGN_PLUVIO_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaign from '../../../campaign/components/campaignDashboard/DashboardCampaign'
import ProgressCard from '../../../components/card/ProgressCard'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import { useParams } from 'react-router'
import { STATION_TYPE_NAME } from 'station/constants/StationConstants'

const PluviometryCampaignDashboard = ({}) => {
    const [dataLoaded, setDataLoaded] = useState(false)
    const [progress, setProgress] = useState(0)

    const {
        pluviometers,
    } = useSelector(store => ({
        pluviometers: store.PluviometryReducer.pluviometers,
    }), shallowEqual)

    const dispatch = useDispatch()
    const { id } = useParams()

    useEffect(() => {
        if (!componentHasHabilitations(H_CAMPAIGN_PLUVIO_DASHBOARD)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CampaignAction.loadCampaignDashboard(p => setProgress(p)))
            .then(() => setDataLoaded(true))
    }, [dispatch, id])

    if (dataLoaded) {
        return (
            <DashboardCampaign
                stations={pluviometers}
                stationType={STATION_TYPE_NAME.pluviometry}
            />
        )
    }
    return <ProgressCard progress={progress} />
}

export default PluviometryCampaignDashboard
